import { MenuItem, Select, Typography, type SelectChangeEvent } from "@mui/material";
import type { FC } from "react";
import {
  filterFieldOperators,
  isRelativeDateCondition,
  mapDateOperator,
  mapToDateCondition,
  type DateOperator,
} from "../../../segment-operation/operators";
import type { UsableAccountPersonField } from "../../../../server/supabase-segment-field-service";
import type { Condition } from "../../types";

export const DateOpSelect: FC<{
  condition: Condition;
  fieldType: Extract<UsableAccountPersonField["field_type"], "DATE" | "MONTH_DAY">;
  handleFieldChange: (value: Partial<Condition>) => void;
  disabled?: boolean;
}> = ({ condition, fieldType, handleFieldChange, disabled }) => {
  return (
    <>
      <Select
        variant="outlined"
        size="small"
        label="Operator"
        onChange={(event: SelectChangeEvent) => {
          handleFieldChange({
            ...condition,
            ...mapToDateCondition(event.target.value as DateOperator, condition),
          });
        }}
        labelId="operator-label"
        value={mapDateOperator(condition)}
        disabled={disabled}
      >
        {filterFieldOperators[fieldType].operators.map((operatorInfo) => (
          <MenuItem key={operatorInfo.operator} value={operatorInfo.operator}>
            {operatorInfo.label()}
          </MenuItem>
        ))}
      </Select>
      {isRelativeDateCondition(condition) ? (
        <Typography variant="caption" color="textSecondary" fontSize={10}>
          * relative to send date
        </Typography>
      ) : null}
    </>
  );
};
